import BoxContent from "@src/component/Desktop/content";
import {
  Button,
  Col,
  Collapse,
  Empty,
  Modal,
  Row
} from "antd";
import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { KEY, lang, MODE_SCREEN } from "../../constants/common.const";
import { MSG_CATCH, showMessage } from "../../constants/utils";

import {
  DeleteOutlined,
  ToTopOutlined
} from "@ant-design/icons";
import Text from "antd/lib/typography/Text";
import { FolderAdd } from "iconsax-react";
import API from "../../api/backend/machineManagement";
import { getIconByFileType } from "../../utils/helper";

const { Panel } = Collapse;
function FileAttachment({ item, index, noIcon = false }) {
  if (!item) return null;

  const fullName = item.attachFileName || "";
  const nameParts = fullName.split(".");
  const fileType = nameParts.pop();
  const fileNameWithoutExt = nameParts.join(".");

  return (
    <li
      key={index}
      style={{
        display: "flex",
        alignItems: "center",

      }}
    ><div style={{marginTop:-7}}>{!noIcon && getIconByFileType(item.attachFileName)}</div>
      <a
        href={item.attachFileUrl}
        title={fullName}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          display: "flex",
          alignItems: "center",
          flex: 1,
          textDecoration: "none",
          minWidth: 0, 
        }}
      >
        <p
          style={{
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            margin: 0,
            paddingRight: 4,

          }}
          className=" mb0"
          
        >
          {fileNameWithoutExt}
        </p>
        <span style={{ flexShrink: 0 }}>.{fileType}</span>
      </a>
    </li>
  );
}

const EquipmentAttach = ({
  mode = MODE_SCREEN.VIEW,
  imageUrl,
  setImage,
  listAttachMachine = [],
  setListAttachMachine,
  setIsDirty
}) => {
  const { allowRoute, roles } = useSelector((state) => state.auth);
  const isViewMode = mode === MODE_SCREEN.VIEW;
  const fileMachineRef = useRef(null);

  const isCustomer = roles === "CUSTOMER" || roles === "SPECIAL_CUSTOMER";
  const uploadFile = async (file, type) => {
    const formData = new FormData();
    const body = {
      attachFileName: file.name,
      type: type,
    };
    formData.append("data", JSON.stringify(body));
    formData.append("file", file);

    try {
      const res = await API.uploadFile(formData);
      const newListAttachMachine = [...listAttachMachine];
      if (type == 1) {
        newListAttachMachine.push(res.data);
        setListAttachMachine([...newListAttachMachine]);
      }

      return res.data;
    } catch (err) {
      showMessage(
        KEY.ERROR,
        (err.response && err.response.data.msg) || MSG_CATCH()
      );
    }
  };

  const handleChangeAttachMachine = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const exceedAmountFile =
      listAttachMachine.length >= 30;
    const exceedSizeFile = file.size > 100 * 1024 * 1024;
    const contentPopup = exceedAmountFile
      ? "ファイル数は 30 を超えないようにしてください"
      : "ファイルサイズは 100MB を超えないようにしてください";
    if (exceedAmountFile || exceedSizeFile) {
      e.preventDefault();
      Modal.destroyAll();
      Modal.confirm({
        centered: true,
        title: "確認",
        content: contentPopup,
        okText: lang.OK,
        cancelText: lang.CANCEL,
      });
      return;
    }

    uploadFile(file, 1);
    setIsDirty(true)
    fileMachineRef.current.value = null;
  };
  const handleDeleteFile = (item) => {
    const newListAttachMachine = [...listAttachMachine];
    setListAttachMachine(
      newListAttachMachine.filter((x) => x.attachFileUrl != item.attachFileUrl)
    );
    setIsDirty(true)
  };
  return (
    <BoxContent style={{ padding: "8px", margin: "8px" }}>
      <Collapse defaultActiveKey={["1"]} expandIconPosition="right">
        <Panel
          header={
            <>
              <FolderAdd variant="Bold" className="first-icon" />
              <span className="bold">{lang.ATTACH_FILE}</span>
            </>
          }
          key="1"
        >
          {listAttachMachine.length === 0 && mode === MODE_SCREEN.VIEW && (
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} className="w100" />
          )}
          <input
            type="file"
            className="d-none"
            hidden={true}
            ref={fileMachineRef}
            onChange={handleChangeAttachMachine}
          />
          <Row className="">
            {mode !== MODE_SCREEN.VIEW && (
              <Col span={24}>
                <Button
                  disabled={listAttachMachine.length >= 30 || isCustomer}
                  type="link"
                  onClick={(e) => fileMachineRef.current.click()}
                  className="buttonPC button--outline --todo-- wAuto"
                  style={{
                    backgroundColor: "#f7f9fc",
                    marginBottom: 10,
                    borderColor: "lightgray",
                  }}
                >
                  <ToTopOutlined />
                  {lang.ATTACH_FILE}
                </Button>
              </Col>
            )}
            {mode !== MODE_SCREEN.VIEW && (
              <Col span={24}>
                <Text type="danger" style={{ fontSize: "12px" }}>
                  {lang.ATTACH_NOTE}
                </Text>
              </Col>
            )}
            <Col span={24} style={{ overflow: "auto" }}>
              {listAttachMachine.length > 0 &&
                listAttachMachine.map((item, index) => {
                  if (item.type == 2 || item.type == 3) return <></>;
                  return (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: "8px",
                        width: "100%",
                        marginBottom: "8px",
                      }}
                      key={index}
                    >
                      <div
                        style={{
                          width: isViewMode ? "100%" :"calc(100% - 50px)"
                        }}
                        span={21}
                      >
                        <FileAttachment item={item} index={index} />
                      </div>

                      {mode !== MODE_SCREEN.VIEW && (
                        <Button
                          style={{
                            minWidth: 40,
                            width: 40,
                            background: "#f7f9fc",
                          }}
                          disabled={isCustomer}
                          onClick={() => handleDeleteFile(item)}
                          icon={<DeleteOutlined />}
                        />
                      )}
                    </div>
                  );
                })}
            </Col>
          </Row>
        </Panel>
      </Collapse>
    </BoxContent>
  );
};

export default EquipmentAttach;
